import React, { Fragment, useEffect, useState } from "react";

import { Form, Input, Space, Select, Flex } from "antd";

import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";

import "@/styles/pages/auth/sign-in.scss";
import { useDispatch } from "react-redux";
import {
  setCurrentForm,
  setIsLoggedIn,
  setModalOpen,
  setUserInfo,
} from "@/reducers/commonSlice";
import { signIn } from "@/services/accounts/signIn";
import { countryList } from "@/helpers/countryList";
import useTriggerNotification from "@/hooks/useTriggerNotification";
import { setIsGuidePanel } from "@/reducers/guideSlice";
import { keyFilterOption } from "@/helpers";
import { updateOneSignalSubscriptionId } from "@/services/users/oneSignalService";
import OneSignal from "react-onesignal";
import { getUserBasicInfo } from "@/services/users/getUserBasicInfo";

// const filterOption = (input, option) => {
//   return (option?.key ?? "").toLowerCase().includes(input.toLowerCase());
// };

const { Option } = Select;

const SignIn = ({ isOpen = false }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { trigger, element } = useTriggerNotification();

  const [isEmailSignIn, setIsEmailSignIn] = useState(false);

  const handleFinish = (value) => {
    if (!isEmailSignIn) {
      if (value.countryCode) {
        value.mobileNumber = value.countryCode + " " + value.mobileNumber;
        delete value.countryCode;
      } else {
        value.mobileNumber = "+91" + " " + value.mobileNumber;
        delete value.countryCode;
      }
      delete value.email;
    } else {
      delete value.mobileNumber;
      delete value.countryCode;
    }

    signIn({
      ...value,
      origin: "web",
    })
      .then((response) => {
        console.log(response);
        dispatch(setModalOpen(false));
        getUserBasicInfo()
          .then((response) => {
            dispatch(setUserInfo(response));
          })
          .catch((error) => {
            console.log(error);
            localStorage.removeItem("token");
          });
        localStorage.setItem("token", response.accessToken);
        dispatch(setIsLoggedIn(true));
        if (response.roles.length === 0) {
          dispatch(setCurrentForm("registrationCategories"));
          return;
        } else if (!response.stage) {
          if (response.roles[0].name === "Guide") {
            dispatch(setCurrentForm("guidePlatform"));
            dispatch(setModalOpen(true));
          } else {
            dispatch(setCurrentForm("journeySelection"));
            return;
          }
        }
        const isGuideRole = response?.roles?.find((x) => x.name === "Guide");
        if (isGuideRole && isGuideRole.isApproved) {
          dispatch(setIsGuidePanel(true));
        } else {
          dispatch(setIsGuidePanel(false));
        }
        let subscriptionId = localStorage.getItem("subscriptionId");
        if (!subscriptionId) {
          subscriptionId = OneSignal?.User?.PushSubscription?.id;
          if (subscriptionId) {
            localStorage.setItem("subscriptionId", subscriptionId);
          }
        }
        // Call the backend API to send the token and subscriptionId
        if (subscriptionId) {
          console.log("user logged in and subscriptionId is present", subscriptionId);
          updateOneSignalSubscriptionId({
            subscriptionId,
          });
        }
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.msg;
        if (errorMessage) {
          switch (errorMessage) {
            case "User not found":
              form.setFields([
                {
                  name: "email",
                  errors: ["User does not exist, please try signing up."],
                },
                {
                  name: "mobileNumber",
                  errors: ["User does not exist, please try signing up."],
                },
              ]);
              break;
            case "Incorrect password":
              form.setFields([
                {
                  name: "password",
                  errors: ["Invalid password, please try again."],
                },
              ]);
              break;
            case "Email not verified yet.":
              form.setFields([
                {
                  name: "email",
                  errors: ["Email not verified yet."],
                },
              ]);
              break;
            default:
              form.setFields([
                {
                  name: "password",
                  errors: [errorMessage],
                },
              ]);
              break;
          }
        }
      });
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen]);

  return (
    <Fragment>
      {element}
      <ModalComponent buttonLabel="Sign In" isOpen={isOpen} className="onboarding-modal">
        <div className="sign-in-modal">
          <div className="heading title-h5">
            Let's get you <br /> <span className="title-h5-1">Signed in!</span>
          </div>
          <div className="form">
            <Form
              name="register"
              initialValues={{ remember: false }}
              layout="vertical"
              size="small"
              form={form}
              onFinish={handleFinish}
            >
              {isEmailSignIn && (
                <Form.Item
                  label="Email"
                  name="email"
                  className=""
                  rules={[
                    {
                      type: "email",
                      required: true,
                      message: "Please enter a valid email address.",
                    },
                  ]}
                >
                  <Input placeholder="Enter your email" />
                </Form.Item>
              )}

              {!isEmailSignIn && (
                <Form.Item label="Phone Number">
                  <Space.Compact style={{ width: "100%" }}>
                    <Form.Item name={"countryCode"} noStyle>
                      <Select
                        virtual={false}
                        showSearch
                        placeholder="Select Contry"
                        defaultValue={"+91"}
                        filterOption={keyFilterOption}
                        style={{
                          maxWidth: "35%",
                        }}
                      >
                        {countryList.map((country) => {
                          return (
                            <Option
                              key={country.name}
                              value={country.phoneCode}
                              label={country.phoneCode}
                            >
                              <Flex justify="start" align="center" gap={"5px"}>
                                <img src={country.flag} height={30} width={30} />
                                {window.innerWidth > 425 ? <span>{country.phoneCode}</span> : <></>}
                              </Flex>
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="mobileNumber"
                      noStyle
                      rules={[
                        {
                          min: 7,
                          max: 14,
                          required: true,
                          message: "Please provide a valid mobile number with WhatsApp.",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        style={{
                          width: "80%",
                        }}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        placeholder="Enter your mobile number"
                      />
                    </Form.Item>
                  </Space.Compact>
                </Form.Item>
              )}

              <div className="forgot-password body-b4-1">
                <span
                  onClick={() => {
                    form.resetFields();
                    setIsEmailSignIn(!isEmailSignIn);
                  }}
                >
                  {isEmailSignIn ? "Sign In using Phone Number" : "Sign In using Email"}
                </span>
              </div>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Password must be at least 8 characters long.",
                  },
                  {
                    min: 8,
                    message: "Password must be at least 8 characters long.",
                  },
                ]}
              >
                <Input.Password placeholder="Enter your password" />
              </Form.Item>
              <div className="forgot-password body-b4-1">
                <span onClick={() => dispatch(setCurrentForm("forgotPassword"))}>
                  Forgot password?
                </span>
              </div>

              <Form.Item>
                <div className="button">
                  <ButtonComponent label="Sign In" varient="primary" htmlType="submit" />
                </div>
              </Form.Item>
            </Form>
            <div className="signup">
              Don’t have an account?{" "}
              <span onClick={() => dispatch(setCurrentForm("requestOTP"))}>Sign Up</span>
            </div>
          </div>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default SignIn;
